/* TPS — <tps-oib-videos>: Özel İş Birliklerimiz sayfasındaki iki dikey Shopify videosu.
   Eski deneyim "autoplay muted loop + görünür kontroller" idi. Burada otomatik oynatma yalnız video görünür olunca
   (IntersectionObserver, %25) başlar, görünmeyince duraklar (veri tasarrufu); prefers-reduced-motion açıksa hiç başlamaz
   (kontroller görünür, kullanıcı oynatır). Kullanıcı kontrollerden durdurduysa yeniden görünür olunca otomatik başlamaz.
   JS yoksa poster + kontroller kalır. Global kirletmez. tps-video-metin.js ile aynı kalıp. */
(() => {
  if (customElements.get('tps-oib-videos')) return;

  class TpsOibVideos extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      if (!this.videos.length || this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.videos.forEach((video) => {
        video.muted = true;
        video.addEventListener('pause', () => {
          if (video.dataset.visible === 'true' && !video.ended) video.dataset.userPaused = 'true';
        });
        video.addEventListener('play', () => {
          delete video.dataset.userPaused;
        });
      });
      if (!('IntersectionObserver' in window)) {
        this.videos.forEach((video) => this.play(video));
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
              video.dataset.visible = 'true';
              if (video.dataset.userPaused !== 'true') this.play(video);
            } else {
              video.dataset.visible = 'false';
              if (!video.paused) video.pause();
            }
          });
        },
        { threshold: [0, 0.25] }
      );
      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    play(video) {
      if (!video.paused) return;
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(() => {});
    }
  }

  customElements.define('tps-oib-videos', TpsOibVideos);
})();
